export default "__VITE_ASSET__D0KUlPk9__"